import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageContext = createContext(null);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language || 'nl');

  const changeLanguage = useCallback((lang) => {
    i18n.changeLanguage(lang);
    setLanguage(lang);
    localStorage.setItem('language', lang);
  }, [i18n]);

  const toggleLanguage = useCallback(() => {
    const newLang = language === 'nl' ? 'en' : 'nl';
    changeLanguage(newLang);
  }, [changeLanguage, language]);

  // Initialize language from localStorage
  useEffect(() => {
    const savedLang = localStorage.getItem('language');
    if (savedLang && savedLang !== language) {
      changeLanguage(savedLang);
    }
  }, [changeLanguage, language]);

  const value = {
    language,
    changeLanguage,
    toggleLanguage,
    isDutch: language === 'nl',
    isEnglish: language === 'en'
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
